export enum PaymentMethodType {
  BANK_TRANSFER = 118,
  PAYPAL = 119,
  CASH = 120,
  WORLDPAY = 121,
}
